import { Component, forwardRef, HostListener, ElementRef, Renderer2, ViewChild, OnInit, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-year-picker',
  templateUrl: './year-picker.component.html',
  styleUrls: ['./year-picker.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => YearPickerComponent),
    multi: true
  }]
})
export class YearPickerComponent implements ControlValueAccessor, OnInit {
  @Input() isSelectMonth = false;
  @ViewChild('picker') pickerRef: ElementRef;
  isInternalChange = false;
  showPopup = false;
  viewMode: 'year' | 'month' = 'year';
  currentYear = new Date().getFullYear();
  startYear = 0;
  years: number[] = [];
  selectedYear: number;
  selectedMonth: number;
  months = Array.from({ length: 12 }, (_, i) => i + 1);

  onChange = (_: any) => { };
  onTouched = () => { };

  constructor(private eRef: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    this.selectedYear = this.currentYear;
    if (this.isSelectMonth) {
      this.selectedMonth = new Date().getMonth() + 1;
    }
    this.initYears(this.selectedYear);
  }

  togglePopup(event?: Event) {
    event && event.stopPropagation();
    this.showPopup = !this.showPopup;
    if (this.isSelectMonth && this.showPopup) {
      this.viewMode = 'month';
    }
  }

  @HostListener('document:click', ['$event.target'])
  onClickOutside(target: HTMLElement) {
    if (!this.eRef.nativeElement.contains(target) && this.showPopup) {
      this.showPopup = false;
      if (!this.isSelectMonth) {
        this.viewMode = 'year';
      }
    }
  }

  initYears(base: number) {
    this.startYear = base - (base % 10);
    this.years = Array.from({ length: 10 }, (_, i) => this.startYear + i);
  }

  prevDecade() {
    if (this.isSelectMonth && this.viewMode === 'month') {
      this.selectedYear -= 1;
      const result = `${this.selectedYear}-${this.selectedMonth.toString().padStart(2, '0')}`;
      this.onChange(result);
    }
    else {
      this.initYears(this.startYear - 10);
    }
  }

  nextDecade() {
    if (this.isSelectMonth && this.viewMode === 'month') {
      this.selectedYear += 1;
      const result = `${this.selectedYear}-${this.selectedMonth.toString().padStart(2, '0')}`;
      this.onChange(result);
    }
    else {
      this.initYears(this.startYear + 10);
    }
  }

  selectYear(year: number, event?: Event) {
    event && event.stopPropagation();
    this.isInternalChange = true;
    this.selectedYear = year;
    if (this.isSelectMonth) {
      this.viewMode = 'month';
      if (!this.selectedMonth) {
        this.selectedMonth = 1;
      }
      const result = `${this.selectedYear}-${this.selectedMonth.toString().padStart(2, '0')}`;
      this.onChange(result);
    } else {
      this.onChange(year);
      this.onTouched();
      this.showPopup = false;
    }
    this.isInternalChange = false;
  }

  selectMonth(month: number, event?: Event) {
    event && event.stopPropagation();
    this.selectedMonth = month;
    const result = `${this.selectedYear}-${month.toString().padStart(2, '0')}`;
    this.onChange(result);
    this.onTouched();
    this.showPopup = false;
    this.viewMode = 'month';
  }

  writeValue(obj: any): void {
    if (obj != null) {
      if (this.isSelectMonth && typeof obj === 'string' && obj.includes('-')) {
        const [year, month] = obj.split('-').map(x => +x);
        this.selectedYear = year;
        this.selectedMonth = month;
        this.initYears(year);
      } else {
        this.selectedYear = +obj || this.currentYear;
        this.selectedMonth = this.isSelectMonth ? (this.selectedMonth || 1) : undefined;
        this.initYears(this.selectedYear);
      }
    }
    this.isInternalChange = false;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}